module.exports = __webpack_public_path__ + "static/img/msg_tab3.0e211ddf.png";